import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { faSquareMinus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import EditModal from "../ui/EditModal.js";
import { normalizar } from "../../common/stringNormalizer.js";

const AddSintomas = () => {
  const [filtroEstado, setFiltroEstado] = useState("activas");
  const [Nombre, setNombre] = useState("");
  const [Descripcion, setDescripcion] = useState("");
  const [Sintomas, setSintomas] = useState([]);
  const [mostrarDescripcion, setMostrarDescripcion] = useState({});
  const [selectedSintoma, setSelectedSintoma] = useState(null);

  useEffect(() => {
    getSintomas();
  }, []);

  const editFields = [
    { name: "Nombre", label: "Nombre Síntoma", type: "text", required: true },
    { name: "Descripcion", label: "Descripción Síntoma", type: "text", required: false }
  ];

  const getSintomas = async () => {
    const response = await api.get(`/sintomas`);
    setSintomas(response.data);
  };

  const createSintoma = async (e) => {
    e.preventDefault();

    const existe = Sintomas.some(
      (sintoma) => normalizar(sintoma.Nombre) === normalizar(Nombre)
    );

    if (existe) {
      Swal.fire({
        icon: "warning",
        title: "Duplicado",
        text: "Ya existe un síntoma con ese nombre.",
        confirmButtonColor: "#3085d6"
      });
      return;
    }

    try {
      await api.post(`/sintomas`, {
        Nombre,
        Descripcion,
      });
      getSintomas();
      setNombre("");
      setDescripcion("");
      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "El síntoma fue guardado exitosamente.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: "Ocurrió un problema al guardar el síntoma.",
      });
    }
  };

  const handleEditSintoma = async (values) => {
    try {
      await api.patch(
        `/sintomas/updateSintoma/${values.IdSintoma}`,
        { Nombre: values.Nombre, Descripcion: values.Descripcion }
      );
      Swal.fire({
        icon: "success",
        title: "Síntoma actualizado",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error al actualizar:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar el síntoma.",
      });
    }
    setSelectedSintoma(null);
    getSintomas();
  };

 const cambiarEstado = async (IdSintoma) => {
  try {
    const sintomaActual = Sintomas.find((s) => s.IdSintoma === IdSintoma);
    const nuevoEstado = sintomaActual.estado === 1 ? "desactivado" : "activado";

    const response = await api.patch(
      `/sintomas/cambiarEstadoSintoma/${IdSintoma}`
    );

    await getSintomas(); // refrescar la tabla

    Swal.fire({
      icon: "success",
      title: `Síntoma ${nuevoEstado}`,
      text: response.data?.msg || `El síntoma fue ${nuevoEstado} correctamente.`,
      timer: 1500,
      showConfirmButton: false,
    });

  } catch (error) {
    console.error("Error al cambiar estado:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text:
        error.response?.data?.msg ||
        "Ocurrió un error al cambiar el estado del síntoma.",
    });
  }
};


const filtrarSintomas = () => {
  if (filtroEstado === "activas") {
    return Sintomas.filter(s => s.estado === 1);
  }
  if (filtroEstado === "inactivas") {
    return Sintomas.filter(s => s.estado === 0);
  }
  return Sintomas;
};



  const columnas = [
    {
      name: "Nombre",
      selector: (row) => row.Nombre,
      sortable: true,
      width: "15vw",
    },
    {
      name: "Descripción",
      cell: (row) => {
        const toggleDescripcion = () => {
          setMostrarDescripcion({
            ...mostrarDescripcion,
            [row.IdSintoma]: !mostrarDescripcion[row.IdSintoma],
          });
        };

        const descripcion = row.Descripcion || "Sin descripción";
        const mostrarBoton =
          row.Descripcion && row.Descripcion.length > 40;

        const estiloCelda = {
          display: "flex",
          alignItems: "center",
          width: "30vw",
          maxHeight: mostrarDescripcion[row.IdSintoma] ? "none" : "40vh",
          overflow: mostrarDescripcion[row.IdSintoma] ? "visible" : "hidden",
        };

        const estiloContenido = {
          flex: 1,
          maxHeight: "40vh",
          textOverflow: mostrarDescripcion[row.IdSintoma]
            ? "clip"
            : "ellipsis",
          whiteSpace: mostrarDescripcion[row.IdSintoma]
            ? "normal"
            : "nowrap",
        };

        return (
          <div style={estiloCelda}>
            <div style={estiloContenido}>
              {!mostrarDescripcion[row.IdSintoma]
                ? descripcion.length > 40
                  ? descripcion.substring(0, 40) + "..."
                  : descripcion
                : descripcion}
            </div>
            {mostrarBoton && (
              <button
                className="btn"
                onClick={(e) => {
                  toggleDescripcion();
                  e.preventDefault();
                }}
              >
                {mostrarDescripcion[row.IdSintoma] ? "Ver Menos" : "Ver Más"}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      width: "30vw",
    },
    {
      cell: (row) => (
        <button
          className="button is-small is-info"
          title="Editar"
          onClick={() => setSelectedSintoma(row)}
        >
          <FontAwesomeIcon icon={faPencil} />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true,
    },
    {
      cell: (row) =>
        row.estado === 1 ? (
          <FontAwesomeIcon
            icon={faSquarePlus}
            style={{ color: "#37ff00", cursor: "pointer" }}
            size="2xl"
            onClick={() => cambiarEstado(row.IdSintoma)}
          />
        ) : (
          <FontAwesomeIcon
            icon={faSquareMinus}
            style={{ color: "#ff0000", cursor: "pointer" }}
            size="2xl"
            onClick={() => cambiarEstado(row.IdSintoma)}
          />
        ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true,
    },
  ];



  const paginationOptionsES = {
  rowsPerPageText: 'Filas por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};
  return (
    <div className="columns mt-5 is-centered">
      <div>
        <div className="notification is-primary">
          <strong>Ingresa el nombre del síntoma.</strong>
        </div>
        <form onSubmit={createSintoma}>
          <div className="field">
            <div className="container">
              <label className="label required">Nombre Síntoma</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={Nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  placeholder="Nombre"
                  required
                />
              </div>
            </div>
          </div>

          <div className="field">
            <div className="container">
              <label className="label required">Descripción Síntoma</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={Descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                  placeholder="Descripción"
                />
              </div>
            </div>
            <div className="field">
              <div>
                <button type="submit" className="button is-success">
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </form>

        <br />

        <div
          style={{ border: "1px solid gray", borderRadius: "8px" }}
          className="is-centered"
        >

<div style={{ display: 'flex', gap: '10px', marginBottom: '1rem' }}>
  {["todas", "activas", "inactivas"].map((estado) => (
    <button
      key={estado}
      onClick={() => setFiltroEstado(estado)}
      type="button"
      style={{
        padding: "6px 16px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: filtroEstado === estado ? "#d1f5d3" : "#f0f2f5",
        color: filtroEstado === estado ? "#075e54" : "#333",
        fontWeight: filtroEstado === estado ? "bold" : "normal",
        boxShadow:
          filtroEstado === estado
            ? "inset 0 0 0 1px #1ebea5"
            : "inset 0 0 0 1px #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        fontSize: "0.9rem",
      }}
    >
      {estado.charAt(0).toUpperCase() + estado.slice(1)}
    </button>
  ))}
</div>


          <DataTable
            pagination
           paginationComponentOptions={paginationOptionsES}
           columns={columnas}
          data={filtrarSintomas()}
            dense={false}
            responsive={false}
          />
        </div>

        {selectedSintoma && (
          <EditModal
            fields={editFields}
            initialValues={selectedSintoma}
            onSubmit={handleEditSintoma}
            title="Editar Síntoma"
            onClose={() => setSelectedSintoma(null)}
          />
        )}
      </div>
    </div>
  );
};

export default AddSintomas;